import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { ChevronDown, Filter } from "lucide-react";
import { librarySourceTypeOptions, type LibrarySourceType } from "@/lib/library";
import { getSourceTypeIcon } from "@/lib/sourceTypeIcons";

export const SourceTypeFilterPopover = ({
  selected,
  onToggle,
  onClear,
}: {
  selected: LibrarySourceType[];
  onToggle: (value: NonNullable<LibrarySourceType>) => void;
  onClear: () => void;
}) => (
  <Popover>
    <PopoverTrigger asChild>
      <Button variant="outline" size="sm" className="h-9 gap-2" aria-label="Filter by source type">
        <Filter className="h-3.5 w-3.5" />
        Source type
        {selected.length > 0 ? (
          <span className="ml-1 inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-semibold text-primary-foreground">
            {selected.length}
          </span>
        ) : null}
        <ChevronDown className="h-3.5 w-3.5 opacity-60" />
      </Button>
    </PopoverTrigger>
    <PopoverContent align="start" className="w-56 p-2">
      <div className="space-y-1">
        {librarySourceTypeOptions.map((opt) => {
          if (!opt.value) return null;
          const Icon = getSourceTypeIcon(opt.value);
          const checked = selected.includes(opt.value);
          return (
            <label
              key={opt.value}
              className="flex cursor-pointer items-center gap-2 rounded-md px-2 py-1.5 text-sm hover:bg-muted"
            >
              <Checkbox
                checked={checked}
                onCheckedChange={() => onToggle(opt.value as NonNullable<LibrarySourceType>)}
                aria-label={opt.label}
              />
              <Icon className="h-3.5 w-3.5 text-primary" />
              <span className="flex-1">{opt.label}</span>
            </label>
          );
        })}
        {selected.length > 0 ? (
          <button
            type="button"
            onClick={onClear}
            className="mt-1 w-full rounded-md px-2 py-1.5 text-left text-xs text-muted-foreground hover:bg-muted"
          >
            Clear source types
          </button>
        ) : null}
      </div>
    </PopoverContent>
  </Popover>
);
